import { configureStore } from "@reduxjs/toolkit";
import viewDataReducers from "./slice/ViewData";
import sidebarsReducers from "./slice/Sidebars";
import appDataReducers from "./slice/AppData";
import searchDataReducers from "./slice/SearchData";
import componentsControlReducers from "./slice/ComponentsControl";
import { defaultFrontOfficeReduxReducers } from "@duosoftbg/nacid-frontoffice-components";

export const store = configureStore({
  reducer: {
    ...defaultFrontOfficeReduxReducers,
    ViewData: viewDataReducers,
    SearchData: searchDataReducers,
    Sidebars: sidebarsReducers,
    AppData: appDataReducers,
    ComponentsControl: componentsControlReducers,
  },
  devTools: process.env.REACT_APP_PROFILE !== "production",
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
